import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { ONE_HOUR } from '@constants';
import { VideoCategory, VideoCategoriesResponse } from '@common/types/api';
import { api } from '@services';

const fetchVideoCategories = () =>
  api
    .get<VideoCategoriesResponse>('/videos/categories?limit=100')
    .then(({ data }) => data.data);

export const useVideoCategoriesQuery = () =>
  useQuery<VideoCategory[], AxiosError>(
    ['video-categories'],
    fetchVideoCategories,
    {
      staleTime: ONE_HOUR * 24,
    },
  );
